export const trackerArticleId = 432;
